import type {
  Machine as DomainMachine,
  MachineBrand as DomainMachineBrand,
  MachineGroup as DomainMachineGroup,
  MachineReferencesResponse,
  MachineEventSearchResponse,
  MachineStatisticsOeeTeepResponse,
  Operation as DomainOperation,
} from '@api/domain/types';
import { SignalREventResponse } from './base';

// === Domain-derived types ===

export type Machine = DomainMachine;
export type MachineStatus = NonNullable<DomainMachine['machineStatus']>;
export type MachineConnection = NonNullable<DomainMachine['machineConnection']>;
export type MachineBrand = DomainMachineBrand;
export type MachineGroup = DomainMachineGroup;
export type Operation = DomainOperation;
export type LatestMachineEvent = NonNullable<DomainMachine['latestMachineEvent']>;
export type MachineProperties = NonNullable<DomainMachine['machineProperties']>[number];
export type ImageDetails = NonNullable<MachineStatus['imageDetails']>[number];
export type MachineAlarm = NonNullable<MachineStatus['machineAlarms']>[number];
export type MachineReference = NonNullable<MachineReferencesResponse['machineReferences']>[number];
export type MachineEventSearchItem = NonNullable<MachineEventSearchResponse['searchResult']>[number];
export type MachineStatisticOEETeep = NonNullable<MachineStatisticsOeeTeepResponse['machineStatistics']>[number];
export type MachineImage = NonNullable<DomainMachine['machineImage']>;

// === App-specific types (no API equivalent) ===

export interface MachineStatistic {
  data: Machine[];
  loaded: boolean;
  maxValueActive: number;
  maxValueProductive: number;
}

export interface MachineListOEE extends Pick<MachineStatistic, 'data' | 'loaded'> {}

export type MachineReferenceWithMachineIds = MachineReference & { machines: { machineId: number }[] };

export interface ErrorStateResponse {
  isError: boolean;
  errorMessage?: string;
}

export interface OperationsMachine extends Pick<Machine, 'machineId' | 'shortName' | 'fullName' | 'isActive'> {}

export interface PaginatedResponse<T> {
  totalResultCount: number;
  searchResult: T[];
}

export enum COUNTING_METHOD {
  LOGICAL = 'Logical',
  MACHINE_COUNTER = 'MachineCounter',
  MACHINE_CONTROL_EVENT = 'MachineControlEvent',
  MACHINE_PART_COUNT = 'MachinePartCount',
}

export interface OnUpdatedMachineStatusSignalRResponse extends SignalREventResponse {
  machineStatus: Record<string, unknown>;
  correlationId: string;
  changes: string[];
}
